import { DomainSite } from "~/api/Api.ts";
import {
  CaaContentData,
  CaaTagOption,
  FormData,
  MxContentData,
  SrvContentData,
} from "~/components/siteSpeed/types.ts";

// used for initializing data
export const contentParsers: {
  SRV: (content: string) => SrvContentData;
  MX: (content: string) => MxContentData;
  CAA: (content: string) => CaaContentData;
} = {
  SRV: (content: string): SrvContentData => {
    const values = content.split(" ");

    return {
      priority: parseInt(values[0]) || 0,
      weight: parseInt(values[1]) || 0,
      port: parseInt(values[2]) || 0,
      content: values.slice(3).join(" ") || "",
    };
  },

  MX: (content: string): MxContentData => {
    const spaceIndex = content.indexOf(" ");

    return {
      priority: parseInt(content.substring(0, spaceIndex)) || 0,
      content: content.substring(spaceIndex + 1) || "",
    };
  },

  CAA: (content: string): CaaContentData => {
    const parts = content.match(/^(\d+)\s+(\w+)\s+"?([^"]*)"?$/);

    return parts
      ? {
          flags: parseInt(parts[1]) || 0,
          tag: parts[2] || "issue",
          content: parts[3] || "",
        }
      : {
          flags: 0,
          tag: "issue",
          content: content,
        };
  },
};

// used before submitting
export const contentFormatters: {
  MX: (data: FormData) => string;
  SRV: (data: FormData) => string;
  CAA: (data: FormData) => string;
} = {
  MX: (data: FormData): string => `${data.priority} ${data.content}`,
  SRV: (data: FormData): string =>
    `${data.priority} ${data.weight} ${data.port} ${data.content}`,
  CAA: (data: FormData): string =>
    `${data.flags} ${data.tag} "${data.content}"`,
};

// fields used for creating "content", grouped by type
export const contentDepsByType: Record<string, (keyof FormData)[]> = {
  MX: ["priority", "content"],
  SRV: ["priority", "weight", "port", "content"],
  CAA: ["flags", "tag", "content"],
  TXT: ["content"],
  SPF: ["content"],
  A: ["content"],
  AAAA: ["content"],
  CNAME: ["content"],
};

export const caaTagOptions: CaaTagOption[] = [
  { value: "issue", label: "issue" },
  { value: "issuewild", label: "issuewild" },
  { value: "iodef", label: "iodef" },
];

export const placeholders: Record<string, string> = {
  A: "192.168.1.1",
  AAAA: "2001:db8::1",
  CNAME: "example.com",
};
export const getDnsNames = (sites: DomainSite[]) => {
  const prerenderingSites = sites.filter((site) => site.prerendering_enabled);
  const allDnsNames = prerenderingSites.flatMap((site) => site?.dns_names);
  const processedDnsNames = allDnsNames.map((dns) =>
    dns === null ? "@" : dns,
  );

  // remove duplicates
  return Array.from(new Set(processedDnsNames));
};
